import React, { ReactElement } from 'react'
import Divider from '@/components/Divider'
import HelpOverview from '@/components/help/HelpOverview'

const HelpPanel = (): ReactElement => {
    return (
        <div className="panel">
            <Divider />
            <HelpOverview />
        </div>
    )
}

export default HelpPanel
